// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1qsRg","range":"MonthRangeSwitch_range__qjPG7","disabled":"MonthRangeSwitch_disabled__2RtEb"};